import { render, staticRenderFns } from "./IntroductionPage.vue?vue&type=template&id=6dfb5fe2&scoped=true"
import script from "./IntroductionPage.vue?vue&type=script&lang=js"
export * from "./IntroductionPage.vue?vue&type=script&lang=js"
import style0 from "./IntroductionPage.vue?vue&type=style&index=0&id=6dfb5fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb5fe2",
  null
  
)

export default component.exports